import React, {useContext, useEffect } from 'react';
import { NextStepsSection, NewsAndStories, VideoHeroBanner, EditorialSection, ExtraordinaryExperiences, RangeSelector, CarouselGallery } from '../../components/index'
import { AppContext } from '../../store/contexts/AppContext.js';
import { login, register } from '../../helpers/SSO.js';
import { scrollTo } from '../../helpers/utils.js';
import { useParams } from 'react-router-dom';

import _ from 'lodash';

export default function Benefits() {

	const context = useContext(AppContext);
	const { cmsConfiguration,  setCustomerProfile, setUserToken, setIsUserLoggedIn, settings } = context;
	const contentSettings = _.get(cmsConfiguration, `settings`, {});
	const {enableLbxLaunchUpdates, showRangeSelector, showCityEvents, showCreatorsCollective, showExtraordinaryExperiences} = contentSettings;
	const screenConfig = _.get(cmsConfiguration, 'labels.benefits-screen', {});
	const creatorsCollectiveLabels = _.get(screenConfig, 'creators-gallery', {});
	const videoHeroBannerConfig = _.get(screenConfig, 'video-hero');
	const loginBanner = _.get(screenConfig, 'login-banner');
	const editoralSectionConfig = _.get(screenConfig, 'reasons-to-join');
	const extraordinaryExperiencesConfig = _.get(screenConfig, 'extraordinary-experiences');
	const rangeConfig = _.get(screenConfig, 'range-selector');
	const nextStepsConfig = _.get(screenConfig, 'next-steps');
	const cityEventsConfig = _.get(screenConfig, 'city-events');
	const displayRangeSelector = showRangeSelector && !!rangeConfig ;
	const onClickActions = {
		'login': () => { 
			login(setCustomerProfile, setUserToken, setIsUserLoggedIn) },
		'register': () => { 
			register() },
		'scroll': (link) => {
			scrollTo(link) }
	}

	const {sectionId} = useParams();

	useEffect(() => {
		if(sectionId) {
			const link = { 
			dataAttributes:[
				{key: 'scrollSelector', value: `#${sectionId}`}
			]}
			scrollTo(link)
	}}, []);

	return (
		<div> 
			<VideoHeroBanner {...{
				...videoHeroBannerConfig, 
				loginBanner, 
				settings, 
				onClickActions
			}}/>
			{ 	enableLbxLaunchUpdates && showCreatorsCollective &&
					<CarouselGallery {...{
						...creatorsCollectiveLabels,
						items: _.get(creatorsCollectiveLabels, 'images', []),
						settings,
						onClickActions,
						id: 'creatorsCollective'
					}}/>
			}
			{ 	!enableLbxLaunchUpdates &&
					<EditorialSection {...{
						...editoralSectionConfig, 
						onClickActions 
					}}/>
			}
			
			{ enableLbxLaunchUpdates && displayRangeSelector &&
				<RangeSelector {...{
					...rangeConfig,
					useGrades: 'LBX',
					hideFilters: true,
					introText: {
						copy: videoHeroBannerConfig.copy,
						heading: videoHeroBannerConfig.heading
					}
				}}/>
			}
			{ 	enableLbxLaunchUpdates && showExtraordinaryExperiences &&
					<ExtraordinaryExperiences {...{
						...extraordinaryExperiencesConfig,
						settings,
						onClickActions,
						enableLbxLaunchUpdates: enableLbxLaunchUpdates
					}}/>
			}
			{	enableLbxLaunchUpdates && showCityEvents &&
				<NewsAndStories {...{
					...cityEventsConfig
				}}/>
			}
			<NextStepsSection {...{
				...nextStepsConfig 
			}}/>
		</div>    
	)
}